import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import { logo, physicianchat, profileimg } from "../Constant/Index";
import MyModal from "../Components/MyModal";
import { useSelector } from "react-redux";
import { physicianSendnotesapi } from "../network/Network";
import Swal from "sweetalert2";

const PhysicianWriteNotes = () => {
	const navigate = useNavigate();
	const physician_detail = useSelector((state) => state?.Auth?.physiciandetail);
	const token = useSelector((state) => state?.Auth?.token);
	const [formErrors, setFormErrors] = useState([]);
	const [notes, setNotes] = useState("");
	const [loading, setLoading] = useState(false);
	const [show, setShow] = useState(false);
	const handleShow = () => setShow(true);
	const handleClose = () => setShow(false);

	//   Post Notes Api
	const Notesapihandler = (e) => {
		e.preventDefault();
		setLoading(true);

		let isValid = true;
		const errors = {};

		// Validate Notes
		if (!notes) {
			errors.notes = ["Notes is required"];
			isValid = false;
		}

		setFormErrors(errors);

		// Clear errors after 3 seconds, only if there are any errors
		if (!isValid) {
			setLoading(false);
			return;
		}

		const data = {
			appointment_id: physician_detail?.booking_detail?.booking_id,
			note: notes,
		};

		physicianSendnotesapi(data, token)
			.then((res) => {
				setFormErrors({});

				Swal.fire({
					position: "center",
					icon: "success",
					title: "Note Successfuly Send",
					showConfirmButton: false,
					timer: 1800,
				});
				navigate(
					`/physician-consultation-detail/${physician_detail?.booking_detail?.booking_id}`,
				);
				setNotes("");
				setLoading(false);
			})
			.catch((err) => {
				setFormErrors({});
				const errorData = err?.response?.data?.errors;

				if (errorData) {
					Object.values(errorData)
						.flat()
						.forEach((message) => {
							Swal.fire({
								position: "center",
								icon: "error",
								text: message,
								showConfirmButton: false,
								timer: 2200,
							});
						});
				}
				setLoading(false);
				// Handle error (e.g., show a message to the user)
			});
	};
	//   =================
	return (
		<>
			<Header />
			<PageHeader pagename="Write Prescription " />
			<section className="main-sidebar user-profile Physician">
				<div className="container">
					<div className="row">
						<div className="col-lg-8 mx-auto">
							<div className="main-profile-content radius-20 p-4">
								<div className="main-headind d-flex align-items-center 	gap-3 mb-3">
									<div className="edit-btn back">
										<Link
											to={`/physician-consultation-detail/${physician_detail?.booking_detail?.booking_id}`}
										>
											<div className="nav-anchor">
												<i className="fa-solid fa-arrow-left"></i>
											</div>
										</Link>
									</div>
									{console.log(physician_detail, "asdkskas")}
									<div className="d-flex gap-3 align-items-center">
										<img
											src={
												physician_detail?.patient_detail?.profile_image_url
													? physician_detail?.patient_detail?.profile_image_url
													: profileimg
											}
											style={{
												width: "50px",
												height: "50px",
												borderRadius: "50%",
											}}
											className="img-fluid"
											alt=""
										/>
										<div>
											<h4 className="main-heading-font level-6 mb-0">
												{physician_detail?.patient_detail?.title}
											</h4>
											<h5 className="primary-medium-font level-8  mb-0 extra-color-15">
												Patient
											</h5>
										</div>
									</div>
								</div>
								<div className="row">
									<div className="col-lg-12">
										<div className="note-write-texterea">
											<img src={logo} className="img-fluid" alt="" />
										</div>
										<div className="row">
											<div className="col-lg-12">
												<div className="write-texterea">
													<div className="form-group col-lg-12">
														<textarea
															className="form-control"
															id="message"
															rows="4"
															name="notes"
															value={notes}
															placeholder="You can Write Notes here for your help"
															onChange={(e) => setNotes(e.target.value)}
														/>
													</div>
												</div>
												<p className="forms-error">{formErrors?.notes}</p>
											</div>
										</div>
										<div className="row">
											<div className="col-lg-12">
												<Link
													className="btn wrapper-btn-main w-100 log-in mt-3 level-7 primary-regular-font text-decoration-none"
													onClick={(e) => Notesapihandler(e)}
												>
													<span className="loading-btn loading bg-wrapper w-100">
														{loading ? (
															<i className="fa fa-spinner"></i>
														) : (
															"Save changes"
														)}
													</span>
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<div className="row">
				<div className="col-lg-12">
					<MyModal show={show} handleClose={handleClose} />
				</div>
			</div>
			<Footer />
		</>
	);
};

export default PhysicianWriteNotes;
